
import Vue from "vue"
import CircularProgressBarWidget from "@/components/CircularProgressBarWidget/CircularProgressBarWidget.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import Component from "vue-class-component"
import {Inject, Prop} from "vue-property-decorator"
import {PlanService} from "@/superannuation/PlanService"
import {DateRangeService} from "@/DateRangeService"
import PageHeader from "@/superannuation/PageHeader.vue"
import PlanSuperScoreWidget from "@/superscore/PlanSuperScoreWidget.vue"
import PieChart from "@/report/PieChart.vue"
import BarChart from "@/report/BarChart.vue"
import ByChart from "@/superannuation/ByChart.vue"
import SuperScoreComponentWidget from "@/components/dashboard/SuperScoreComponentWidget.vue"
import {MemberDimension, MemberSnapshotMeasure} from "@/cube"

class ReportReadyEvent {
  filename: string
  metadata: any
  disposition = "inline"
  errors: Array<string>

  constructor(filename: string) {
    this.filename = filename
  }
}

@Component({
  components: {
    ByChart,
    CircularProgressBarWidget,
    MetricTrendWidget,
    PageHeader,
    PlanSuperScoreWidget,
    PieChart,
    BarChart,
    SuperScoreComponentWidget,
  },
})
export default class DashboardReport extends Vue {
  @Inject()
  planService: PlanService

  @Inject()
  dateRangeService: DateRangeService

  @Prop({default: false})
  show: boolean

  SuperScoreArea = SuperScoreArea

  metricStore: MetricStore

  countMembers = MemberSnapshotMeasure.countMembers
  gender = [MemberDimension.gender]
  addressState = MemberDimension.addressState

  pageReady: boolean | null = null

  // eslint-disable-next-line @typescript-eslint/ban-types
  sendReportReady: (message: string, errors: {}) => {} | undefined

  goBack() {
    void this.$router.push("/dashboard")
  }

  get numberOfMembers() {
    return this.metricStore.get(this.$metrics.MemberSnapshot.countMembers).end
      ?.amount
  }

  get numberOfExitedMembers() {
    return this.metricStore.getHistory(
      this.$metrics.MemberSnapshot._count_ExitedMember_True
    ).accumulatedAmount
  }

  get numberOfTfn() {
    return this.metricStore.get(this.$metrics.MemberSnapshot.countMembers, {
      [this.$cubes.MemberSnapshotCube.taxFileNumberProvided]: "1|Yes",
    }).end?.amount
  }

  get numberOfMobiles() {
    return this.metricStore.get(this.$metrics.MemberSnapshot.countMembers, {
      [this.$cubes.MemberSnapshotCube.mobileNumberProvided]: "1|Yes",
    }).end?.amount
  }

  get numberOfEmails() {
    return this.metricStore.get(this.$metrics.MemberSnapshot.countMembers, {
      [this.$cubes.MemberSnapshotCube.emailAddressProvided]: "1|Yes",
    }).end?.amount
  }

  async created() {
    this.metricStore = new MetricStore()

    if (this.planService.current == null) {
      const planId = <string | null>this.$route.query.planId

      if (planId === null) {
        this.planService.current = this.planService.getPlanFromSessionStorage()
      } else {
        this.sendMessage(`Creating report pages using planId: ${planId}`)

        await this.planService
          .get(planId)
          .then(() =>
            this.sendMessage(`Loaded plan: ${this.planService.current!.name}`)
          )
          .catch(reason => {
            this.sendMessage(`Failed loading plan: ${String(reason)}`)
          })
      }

      await this.dateRangeService.setPlan(this.planService.current!.id)

      if (this.dateRangeService.dateRangeSelector?.selected !== undefined) {
        this.metricStore
          .update(
            this.planService.current!.id,
            this.dateRangeService.dateRangeSelector.selected
          )
          .then(() => (this.pageReady = true))
          .catch(error => error)
      }
    }

    setTimeout(() => {
      if (this.dateRangeService.dateRangeSelector?.selected !== undefined) {
        this.metricStore
          .update(
            this.planService.current!.id,
            this.dateRangeService.dateRangeSelector.selected
          )
          .then(() => (this.pageReady = true))
          .catch(() => console.log("Plan switch failed"))
      }
    }, 5000)

    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (typeof window.sendReportReady === "function") {
        this.sendMessage("Event: sendReportReady")
        const reportReadyEvent = new ReportReadyEvent(
          "PolicyCommitteeReport.pdf"
        )
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.sendReportReady("", reportReadyEvent)
      }
    }, 15000)
  }

  private sendMessage(message: string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window.sendReportMessage === "function") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.sendReportMessage(message)
    }
  }
}
